
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import Cocktails from './cocktails';
import EventsScreen from './events';
import CategoriesScreen from './categories';
import Alcoholic from './alcoholic';
import ListProducts from './ListProducts';
import { getData } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';

function Index({dishs2, setShowListProduct, setShowHappy}) { 

    const {i18n} = useTranslation();
    const [showCategories, setshowCategories] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);
    const [showEvents, setShowEvents] = useState(false);
    const [showListProduct, setShowListProduct2] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [Beverages, setBeverages] = useState(false);
     const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);

    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);

    useEffect(() => {
        menus.map((item) => {
            if (item.id === 628) {
                setBeverages(item);
            }
        });
    }, [menus]);

    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent goCategories={() => {
                setShowListProduct2(true)
                setdishs(Beverages)
        }}  showBack={true} showCocktails={ setShowCocktails} showEvents={ setShowEvents} setShowListProduct={setShowListProduct} goHome={setShowHappy} >
                <div style={{padding: '0 20px', height: 780, overflowY: 'auto'}}>
                    

                    
                     <div style={{display: 'flex', justifyContent: 'center', marginBottom: 1, marginTop: 1}}>
                        <img
                            src={require('./assets/specials1.png')}
                            onContextMenu={(e) => e.preventDefault()}
                            style={{width: '100%', height: 170, objectFit: 'contain', pointerEvents: 'none'}}
                        />
                        
                    </div>

                    <br />

                     <div style={{display: 'flex', justifyContent: 'center', marginBottom: 1, marginTop: 1}}>
                        <img
                            src={require('./assets/specials2.png')}
                            onContextMenu={(e) => e.preventDefault()}
                            style={{width: '100%', height: 170, objectFit: 'contain', pointerEvents: 'none'}}
                        />
                        
                    </div>
                    <br />

                     <div style={{display: 'flex', justifyContent: 'center', marginBottom: 1, marginTop: 1}}>
                        <img
                              src={require('./assets/specials3.png')}
                            onContextMenu={(e) => e.preventDefault()}
                            style={{width: '100%', height: 170, objectFit: 'contain', pointerEvents: 'none'}}
                        />
                        
                    </div>
                    <br />


                     <div style={{display: 'flex', justifyContent: 'center', marginBottom: 1, marginTop: 1}}>
                        <img
                              src={require('./assets/specials4.png')}
                            onContextMenu={(e) => e.preventDefault()}
                            style={{width: '100%', height: 170, objectFit: 'contain', pointerEvents: 'none'}}
                        />
                        
                    </div>




                   

                </div>

                {showListProduct && <ListProducts
                    dishs={dishs}
                    setShowListProduct={setShowListProduct2}
                />}

                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showCocktails && <Cocktails setShowHappy={setShowCocktails} />}
                {showEvents && <EventsScreen setShowHappy={setShowEvents} />}  
                {showCocktails && <Alcoholic setShowHappy={setShowCocktails} />}
            </LayoutContent>
        </div>
    );
}
export default Index;